import { HttpService } from '@/data/http/http-service';
import { PdfLocaFilelUrl } from '@/domain/pdf-reports/pdf-reports.type';
import { ExportReportProjectActionParams } from '@/domain/project/actions/export-report-project.action';
import { ProjectExportReportProjectGateway } from '@/domain/project/gateways/export-report-project.gateway';

export class ApiProjectPdfReportGateway implements ProjectExportReportProjectGateway {
  private httpProject = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });

  async exportPdfReport(
    params: ExportReportProjectActionParams,
  ): Promise<PdfLocaFilelUrl> {
    // Call the pdf service on project-api
    const query_params = `?export_type=${params.exportType}&project_type=${params.projectType}`;
    const path = `/project-pdf-reports/${params.projectId}/${params.filename}`;
    const url = `${path}${query_params}`;
    const response = await this.httpProject.get(url, {
      responseType: 'blob',
    });

    if (response.status !== 200) {
      throw new Error(`PDF export failed with status: ${response.status}`);
    }

    if (response.headers['content-type'] !== 'application/pdf') {
      throw new Error('Invalid content type received from PDF service');
    }

    // Create a temporary URL for the Blob, and emulate a download
    const blobObj = await response.data;

    const temporaryFileUrl = URL.createObjectURL(blobObj);
    const link = document.createElement('a');
    link.href = temporaryFileUrl;
    link.setAttribute('download', params.filename);
    link.click();

    // Clean up the temporary URL long after the user receives the notification
    setTimeout(() => URL.revokeObjectURL(temporaryFileUrl), 2 * 60_000); // 2 minutes

    return temporaryFileUrl;
  }

  async exportScoreCards(
    params: ExportReportProjectActionParams,
  ): Promise<void> {
    const path = `/project-score-cards-reports/${params.projectId}/${params.filename}`;
    const cards = ['#card1', '#card2', '#card3', '#card4'];
    const cardsParams = new URLSearchParams();
    cards.forEach((value) => cardsParams.append('cards', value));
    const query_params = `?export_type=${params.exportType}&project_type=${params.projectType}&${cardsParams.toString()}`;
    const url = `${path}${query_params}`;
    const response = await this.httpProject.get(url, {
      responseType: 'blob',
    });

    if (response.status !== 200) {
      throw new Error(`ZIP export failed with status: ${response.status}`);
    }

    if (response.headers['content-type'] !== 'application/zip') {
      throw new Error('Invalid content type received from ZIP service');
    }

    // Create a temporary URL for the Blob, and emulate a download
    const blobObj = await response.data;

    const temporaryFileUrl = URL.createObjectURL(blobObj);
    const link = document.createElement('a');
    link.href = temporaryFileUrl;
    link.setAttribute('download', params.filename);
    link.click();

    // Clean up the temporary URL long after the user receives the notification
    setTimeout(() => URL.revokeObjectURL(temporaryFileUrl), 2 * 60_000); // 2 minutes
  }
}
